import { render } from "./App.vue?vue&type=template&id=2ce1245a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2ce1245a&lang=scss"
import "./App.vue?vue&type=style&index=1&id=2ce1245a&lang=scss"

import exportComponent from "../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__